import { render, staticRenderFns } from "./PracticaFilaThree.vue?vue&type=template&id=72059d58&"
import script from "./PracticaFilaThree.vue?vue&type=script&lang=js&"
export * from "./PracticaFilaThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports